import { makeStyles, createTheme } from "@material-ui/core";

// Update log
// FB  6192   02/06/2023  DK  Style sheet for PE pages

const ThemeColor = "#18a2b8";

const theme = createTheme({
  palette: {
    primary: {
      main: ThemeColor,
    },
  },
});

const useStyles = makeStyles({
  appBar: {
    backgroundColor: ThemeColor,
    display: "flex",
    flexDirection: "row",
  },
  appTitle: {
    flexGrow: 1,
    color: "white",
  },
  logo: {
    maxWidth: 400,
    maxHeight: 150,
    [theme.breakpoints.down("xs")]: {
      maxWidth: 250,
      maxHeight: 70,
    }
  },
  buttonActive: {
    backgroundColor: "#B9E3E9",
    color: "black",
    textTransform: "capitalize",
    borderRadius: "15px",
    pointerEvents: "none",
    width: "-webkit-fill-available",
  },
  buttonInactive: {
    backgroundColor: "white",
    color: ThemeColor,
    textTransform: "capitalize",
    borderRadius: "15px",
    width: "-webkit-fill-available",
  },
  navigationButton: {
    backgroundColor: ThemeColor,
    color: "white",
    textTransform: "capitalize",
    borderRadius: "15px",
    "&:hover": {
      backgroundColor: "#46B4C6",
    },
  },
  disabledButton: {
    backgroundColor: "lightgray",
    textTransform: "capitalize",
    color: "grey",
    borderRadius: "15px",
  },
  flexend_Grid: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexBasis: "unset",
  },
  flexstart_Grid: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    flexBasis: "unset",
  },
  flexcenter_Grid: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexBasis: "unset",
  },
  provider_Card: {
    maxWidth: 450,
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("md")]: {
      maxWidth: 300,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 250,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "80%",
      display: "flex",
      flexDirection: "column",
    },
  },
  card_Avatar: {
    "&.MuiAvatar-root": {
      height: 170,
      width: 170,
    },
  },
  slotspage_Avatar: {
    "&.MuiAvatar-root": {
      height: 120,
      width: 120,
    },
  },
  slotspage_Card: {
    maxWidth: 450,
    display: "flex",
    flexDirection: "row",
  },
  slotslocation_Card: {
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "row",
    },
  },
  slotslocation_Avatar: {
    "&.MuiAvatar-root": {
      height: 120,
      width: 120,
      [theme.breakpoints.down("xs")]: {
        height: 90,
        width: 90,
      },
    },
  },
  location_Card: {
    maxWidth: 400,
    display: "flex",
    flexDirection: "row",
    minWidth: "70%",
    [theme.breakpoints.down("md")]: {
      maxWidth: 300,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: 250,
      display: "flex",
      flexDirection: "column",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "100%",
      display: "flex",
      flexDirection: "column",
    },
  },
  location_Cardmedia: {
    height: 170,
    width: 170,
  },
  bydateProviderCard: {
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      flexDirection: "column",
    },
  },
  byDateScrollbar: {
    "&::-webkit-scrollbar": {
      width: "4px",
      height: "10px",
      backgroundColor: "lightgray",
    },

    "&::-webkit-scrollbar-thumb:horizontal": {
      backgroundColor: "rgba(0,0,0,.5)",
    },
  },
  dropdown: {
    maxHeight: 150,
    "&:hover": {
      color: "white",
      backgroundColor: ThemeColor,
    },
  },
  dropdown_nomargin: {
    "& .MuiFormControl-marginNormal": {
      margin: 0,
    },
  },
  datepickerroot: {
    "& .MuiIconButton-root": {
      color: ThemeColor,
    },
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
  fabButton: {
    margin: theme.spacing(2),
    "&.MuiFab-root": {
      backgroundColor: "#2FABBF",
      color: "white",
    },
    "&:hover": {
      backgroundColor: "#46B4C6",
    },
  },
  navigationArrows: {
    color: ThemeColor,
  },
  otp: {
    width: "2rem !important",
    height: "2rem",
    margin: "0 0.5rem",
    fontSize: "1rem",
    border: "2px solid gray",
    "&:focus": {
      border: "2px solid #18a2b8",
      outlineColor: "transparent",
    },
  },
  otpError: {
    border: "2px solid red",
  },
  radioGroup: {
    "&.MuiFormGroup-root": {
      flexDirection: "row",
    },
  },
  disabledTextfield: {
    "&.Mui-disabled": {
      color: "black",
    },
  },
  autocompleteIcon: {
    "& .MuiSvgIcon-root": {
      fontSize: "2rem"
    }
  },
  flexRow: {
    display: "flex",
    flexDirection: "row",
  },
  topBarItem: {
    alignSelf: "flex-start",
    textAlign: "center",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px 0"
  },
  timeSlotItem: {
    borderRadius: "16px",
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EDEEEE",
    maxWidth: "70%",
    paddingRight: "5px",
    paddingLeft: "5px",
    cursor: "pointer",
    fontSize: "smaller",
    height: "25px",
    margin: "5px 5px 0 0",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
  },
  
  slots_paper: {
    border: "0",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    alignContent: "center",
    display: "flex",
    boxShadow: "none",
    marginBottom: 10,
  },
  slot: {
    backgroundColor: "#EDEEEE",
    padding: 5,
    borderRadius: "10px",
    fontSize: "smaller",
    "&:hover, &:focus": {
      backgroundColor: "#25aae1",
      color: "#fff",
    },
    margin: 0,
  },
  selectedSlot_subheader: {
    color: "white"
  },
  buttonActive_LP: {
    backgroundColor: "#B9E3E9",
    color: "black",
    textTransform: "capitalize",
    borderRadius: "15px",
    pointerEvents: "none",
    width: "350px",
    height: "40px"
  },
  buttonInactive_LP: {
    backgroundColor: "white",
    color: "#18a2b8",
    textTransform: "capitalize",
    borderRadius: "15px",
    width: "350px",
    height: "40px"
  },
});

export default useStyles;
